<template>
    <div v-show="!selectedTab.tabId" id="register-departDoctor-departList">
        <no-record :condition="departs" tips='没有找到科室信息'></no-record>
        <div v-if="departs.length > 0">
            <ul class="dept-scroll left-list list">
                <li @click="onSelectedDepart(index)" v-for="(item,index) in departs" class="dept-item list-item" :id="'register-departDoctor-li-depart-'+index"
                    :class="{active: item.deptId == selectedDepart.deptId }">
                    {{item.deptName}}
                </li>
            </ul>
            <ul class="dept-scroll right-list list">
                <li @click="onSelectedSubDepart(item)" v-for="(item,index) in subDeparts" class="dept-item list-item" :id="'register-departDoctor-li-subDepart-'+index"
                    @touchstart.stop="onTouchStartSubDepart(item)" @touchend.stop="onTouchEndSubDepart()" @touchcancel.stop="onTouchEndSubDepart()"
                    :class="{active: item.deptId == touchedSubDepart.deptId }">
                    {{item.deptName}}
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import NoRecord from 'NoRecord';
export default {
        props: {
            selectedTab: Object,
            selectedArea: Object,
            departs: Array
        },
        components: {
            NoRecord
        },
        data() {
            return {
                selectDepartIndex: 0,
                selectedSubDepart: {},
                touchedSubDepart: {}
            };
        },
        computed:{
            selectedDepart(){
                return this.departs[this.selectDepartIndex] || {};
            },
            subDeparts() {
                if(this.departs.length === 0){
                    return [];
                }
                return this.departs[this.selectDepartIndex]["children"] || [];
            }
        },
        mounted() {
            this.refresh();
        },
        methods: {
            refresh() {

            },

            onSelectedDepart: function(index) {
                this.selectDepartIndex = index;
            },

            onSelectedSubDepart: function(item) {
                this.selectedSubDepart = item;
                this.$store.commit('updateParam', {
                    namespace: 'register',
                    depart: item,
                    area: this.selectedArea
                })
                window.localStorage.tabId = "0";
                this.$router.push('DateDoctorSchedule');
            },

            onTouchStartSubDepart: function(item){
                this.touchedSubDepart = item;
            },
            onTouchEndSubDepart: function(){
                this.touchedSubDepart = {};
            }
        }
}
</script>
<style lang="scss" >
    @import '../../../static/sass/_variable.scss';
    .dept-scroll {
        position: absolute;
        top: 0;
        bottom: 0;
        overflow-y: auto;
    }
</style>


// WEBPACK FOOTER //
// DepartList.vue?20b1c3ae